import { StockReductionCauseRowActions } from 'modules/inventory/settings/stock-reduction-cause/components/StockReductionCauseRowActions';
import { CellAlign, CellType, EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { IStockReductionCause } from 'modules/inventory/settings/stock-reduction-cause/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { STOCK_REDUCTION_CAUSE_PERMISSIONS } from 'modules/inventory/settings/stock-reduction-cause/constants/stock-reduction-cause.permissions';
import { BooleanCell } from 'modules/common/components/BooleanCell';
import PriceCell from 'modules/security/audit-logs/components/TableCells/PriceCell';

export const stockReductionCauseNameColumn: HeadCell<IStockReductionCause> = {
  field: 'name',
  headerName: 'stockReductionCause:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: IStockReductionCause) => <EditLink entityId={data?._id as string}>{name}</EditLink>,
};

export const reductionCauseNameColumn: HeadCell<IStockReductionCause> = {
  field: 'cause.name',
  headerName: 'stock:fields.reductionCause',
  disablePadding: false,
};

export const stockReductionCauseDescriptionColumn: HeadCell<IStockReductionCause> = {
  field: 'description',
  headerName: 'stockReductionCause:fields.description',
};

export const stockReductionCauseResponsibleColumn: HeadCell<IStockReductionCause> = {
  field: 'requiresResponsible',
  headerName: 'stockReductionCause:fields.requiresResponsible',
  align: CellAlign.CENTER,
  component: BooleanCell,
};

export const stockReductionCauseIsSystemColumn: HeadCell<IStockReductionCause> = {
  field: 'isSystem',
  headerName: 'stockReductionCause:fields.isSystem',
  align: CellAlign.CENTER,
  component: BooleanCell,
};

export const stockReductionCauseEvidenceColumn: HeadCell<IStockReductionCause> = {
  field: 'requiresEvidence',
  headerName: 'stockReductionCause:fields.requiresEvidence',
  component: BooleanCell,
  align: CellAlign.CENTER,
};

export const stockReductionCauseCompensationColumn: HeadCell<IStockReductionCause> = {
  field: 'requiresSupplierCompensation',
  headerName: 'stockReductionCause:fields.compensation',
  component: BooleanCell,
  align: CellAlign.CENTER,
};

export const stockReductionCauseActionsColumn: HeadCell<IStockReductionCause> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: STOCK_REDUCTION_CAUSE_PERMISSIONS.STOCK_REDUCTION_CAUSE_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: StockReductionCauseRowActions,
};

export const stockAverageCostPerOccurrenceColumn: HeadCell<IStockReductionCause> = {
  field: 'averageCostPerOccurrence',
  headerName: 'stock:fields.averageCostPerOccurrence',
  align: CellAlign.CENTER,
  type: CellType.NUMBER,
};

export const stockAverageQuantityPerOccurrenceColumn: HeadCell<IStockReductionCause> = {
  field: 'averageQuantityPerOccurrence',
  headerName: 'stock:fields.averageQuantityPerOccurrence',
  align: CellAlign.CENTER,
  type: CellType.NUMBER,
};

export const stockTotalCostLostColumn: HeadCell<IStockReductionCause> = {
  field: 'totalCostLost',
  headerName: 'stock:fields.totalCostLost',
  align: CellAlign.CENTER,
  type: CellType.NUMBER,
  renderCell: (value: number) => <PriceCell value={value} />,
};

export const stockTotalQuantityLostColumn: HeadCell<IStockReductionCause> = {
  field: 'totalQuantityLost',
  headerName: 'stock:fields.totalQuantityLost',
  align: CellAlign.CENTER,
  type: CellType.NUMBER,
};

export const stockUniqueItemsAffectedColumn: HeadCell<IStockReductionCause> = {
  field: 'uniqueItemsAffected',
  headerName: 'stock:fields.uniqueItemsAffected',
  align: CellAlign.CENTER,
  type: CellType.NUMBER,
};

export const stockReductionCauseColumns: Array<HeadCell<any>> = [
  stockReductionCauseNameColumn,
  stockReductionCauseDescriptionColumn,
  stockReductionCauseResponsibleColumn,
  stockReductionCauseEvidenceColumn,
  stockReductionCauseCompensationColumn,
  stockReductionCauseIsSystemColumn,
  createdATColumn,
  stockReductionCauseActionsColumn,
];

export const topReductionCauseColumns: Array<HeadCell<any>> = [
  reductionCauseNameColumn,
  stockTotalCostLostColumn,
  stockTotalQuantityLostColumn,
  stockAverageCostPerOccurrenceColumn,
  stockAverageQuantityPerOccurrenceColumn,
  stockUniqueItemsAffectedColumn,
];
